import React, { useEffect, useRef } from "react";
import { gsap } from "../animations/gsap";
import avatar from "../Images/avatar.png";
import "../CSS/Preloader.css";

export default function Preloader({ onComplete }) {
  const containerRef = useRef(null);
  const avatarRef = useRef(null);
  const glowRef = useRef(null);

  useEffect(() => {
    // Float infinito
    gsap.to(avatarRef.current, {
      y: -18, duration: 1.8, ease: "sine.inOut", yoyo: true, repeat: -1,
    });
    // Glow pulsante
    gsap.to(glowRef.current, {
      scale: 1.3, opacity: 0.4, duration: 1.4, ease: "sine.inOut", yoyo: true, repeat: -1,
    });
  }, []);

  useEffect(() => {
    if (!onComplete) return;
    const timeout = setTimeout(() => {
      gsap.killTweensOf(avatarRef.current);
      gsap.to(containerRef.current, {
        opacity: 0, duration: 0.5, ease: "power2.in", onComplete,
      });
    }, 400);
    return () => clearTimeout(timeout);
  }, [onComplete]);

  return (
    <div ref={containerRef} className="preloader">
      <div className="preloader-inner">
        <div className="preloader-glow-wrap">
          <div ref={glowRef} className="preloader-glow" />
          <img ref={avatarRef} src={avatar} alt="Cargando" className="preloader-avatar" />
        </div>
        <span className="preloader-text">Cargando</span>
      </div>
    </div>
  );
}
